import api from './api'

// Login: three possible 200 outcomes (master plan section 3):
//   A. access_token present            → logged in
//   B. two_factor: 'setup_required'    → challenge issued, must enrol
//   C. two_factor: 'code_required'     → challenge issued, must verify
//
// The discriminator on the client is `access_token`. A body without
// it must NEVER be treated as authenticated. Master plan section 5.1
// flagged the previous `if (access_token)` guard (no else) as a bug:
// challenge responses were silently swallowed.
const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials)

  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token)
    localStorage.setItem('user', JSON.stringify(response.data.user))
  }

  return response.data
}

const logout = async () => {
  try {
    await api.post('/auth/logout')
  } finally {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }
}

const getCurrentUser = async () => {
  const response = await api.get('/auth/me')
  return response.data
}

const refreshToken = async () => {
  const response = await api.post('/auth/refresh')

  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token)
  }

  return response.data
}

// Fetch the enrolment payload (base32 secret, otpauth URI, SVG QR) for
// a `setup_required` challenge. Public route, throttled server-side by
// PECO_Login's `two-factor` limiter.
const setupTwoFactor = async (challengeToken) => {
  const response = await api.post('/auth/2fa/setup', {
    challenge_token: challengeToken,
  })
  return response.data
}

// Verify a 6-digit TOTP code against a setup or verify challenge.
const verifyTwoFactor = async (challengeToken, code) => {
  const response = await api.post('/auth/2fa/verify', {
    challenge_token: challengeToken,
    code,
  })

  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token)
    localStorage.setItem('user', JSON.stringify(response.data.user))
  }

  return response.data
}

// Burn a recovery code against a verify challenge.
const useRecoveryCode = async (challengeToken, recoveryCode) => {
  const response = await api.post('/auth/2fa/recovery', {
    challenge_token: challengeToken,
    recovery_code: recoveryCode,
  })

  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token)
    localStorage.setItem('user', JSON.stringify(response.data.user))
  }

  return response.data
}

const authService = {
  login,
  logout,
  getCurrentUser,
  refreshToken,
  setupTwoFactor,
  verifyTwoFactor,
  useRecoveryCode,
}

export default authService
